'use client';

import { PrismicNextLink } from '@prismicio/next';

import { ArrowRight } from '@/assets/icons/ArrowRight';
import { asLink, KeyTextField, LinkField } from '@prismicio/client';
import Link from 'next/link';
import { memo } from 'react';
import staticStyles from './button.module.scss';

export type ButtonVariation = 'primary' | 'transparent' | 'blue' | 'white';

export interface ButtonProps {
  link?: LinkField | string;
  text?: KeyTextField | string;
  styles?: string;
  variation?: ButtonVariation;
  isArrow?: boolean;
  onClick?: () => void;
  isBlinking?: boolean;
}

const ButtonComponent = ({
  link,
  text,
  styles,
  variation = 'primary',
  isArrow,
  onClick,
  isBlinking = false,
}: ButtonProps) => {
  const buttonStyles = `${styles} ${staticStyles.button} ${staticStyles[variation]} ${isBlinking ? staticStyles.blinkingButton : ''}`;

  const formLink =
    (typeof link !== 'string' && asLink(link) === '/form') || link === '/form';

  if (formLink) {
    return (
      // eslint-disable-next-line @next/next/no-html-link-for-pages
      <a href="/form" className={buttonStyles} onClick={onClick}>
        <div className={staticStyles.text_wrapper}>
          <span>{text}</span>
          <span>{text}</span>
        </div>
        {isArrow && <ArrowRight />}
      </a>
    );
  }

  return typeof link === 'string' ? (
    <Link href={link} className={buttonStyles} onClick={onClick}>
      <div className={staticStyles.text_wrapper}>
        <span>{text}</span>
        <span>{text}</span>
      </div>
      {isArrow && <ArrowRight />}
    </Link>
  ) : (
    <PrismicNextLink className={buttonStyles} field={link} onClick={onClick}>
      <div className={staticStyles.text_wrapper}>
        <span>{text}</span>
        <span>{text}</span>
      </div>
      {isArrow && <ArrowRight />}
    </PrismicNextLink>
  );
};

export const Button = memo(ButtonComponent);
